import React, { useState, useEffect } from "react";
import './index.scss';
import ReactHtmlParser from "react-html-parser";
import {reactParserCommonOptions, generateTestId} from "../../app/functions";
import banner_text_background from  '../../assets/icons/banner-text-background.png';
import { getMediaPath } from "../../app/functions";

const ImageHeader = props => {
    const {title, subtitle, children, image = '', testID = 'image-header'} = props;
    const [textAlignment, setTextAlignment] = useState('left');
    const hrefName = decodeURIComponent(window.location.href.split('/').pop());
    let bannerClassName = 'bg-img2';
    
    if(hrefName === 'מומחים'){
        bannerClassName = 'bg-img2 bg-img2-experts';
    }

    useEffect(() => {
        const updateTextAlignment = () => {
            if (title) {
                const isMobile = window.innerWidth < 768; // tablet breakpoint
                if (isMobile) {
                    const titleLength = title.length;
                    const isLongText = titleLength > 30; // threshold for long text
                    setTextAlignment(isLongText ? 'center' : 'left');
                } else {
                    setTextAlignment('left'); // default for larger screens
                }
            }
        };

        updateTextAlignment();
        window.addEventListener('resize', updateTextAlignment);
        
        return () => {
            window.removeEventListener('resize', updateTextAlignment);
        };
    }, [title]);

    const titleStyle = {
        textAlign: textAlignment
    };

    return (
        <section className='image-header-banner' testId={generateTestId(testID, 'banner')}>
            {image && image !== null && image !== '' && (
                <img 
                    className='bg-img' 
                    src={getMediaPath(image)} 
                    alt=''
                    testId={generateTestId(testID, 'background')}
                />
            )}
            <div className='title-wrapper' testId={generateTestId(testID, 'title-wrapper')}>
                {title && (
                    <h1 className='title' testId={generateTestId(testID, 'title')} style={titleStyle}>
                        <img 
                            src={banner_text_background}  
                            className={bannerClassName}
                            testId={generateTestId(testID, 'text-background')}
                            alt=''
                        />
                        {title}
                    </h1>
                )}
                {subtitle && (
                    <h2 className='sub-title' testId={generateTestId(testID, 'subtitle')}>
                        {ReactHtmlParser(subtitle, reactParserCommonOptions())}
                    </h2>
                )}
                {children}
            </div>
        </section>
    )
};

export default ImageHeader;
